<template>
  <div>
    <LayoutTitle :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
      <FormLayout
        ref="projectForm" 
        :readOnly="readOnly"
        :model="projectInfo"
        :list="generatePage(index)"
        @on-change-tree="checkPerson" 
        @on-change-all="checkMember">
      </FormLayout>
    </LayoutTitle>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'
import generateList from './generate-form'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import { submitExternalSignUp, getExternalSignUp, editExternalSignUp } from '../../interface'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      projectInfo: {},
      dictMap: {},
      formLayout: [],
      dynamicList: []
    }
  },
  created () {
    this.setInitData()
    this.getCodeTable('BOE29')
    this.getCodeTable('BOE30')
    this.getCodeTable('BOE31')
  },
  inject: ['getApplicationObjectId'],
  methods: {
    //设置初始数据
    setInitData () {
      const idMap = JSON.parse(sessionStorage.getItem('idMap'))
      const nameMap = JSON.parse(sessionStorage.getItem('nameMap'))
      this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
      this.readOnly = this.$decode(this.$route.query.type) == 'see'
      this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
      this.orgName = this.$decode(sessionStorage.getItem(nameMap[this.bizLineCode]) || '')
      this.$set(this.projectInfo, 'rewardOrgName', this.orgName)
      this.$set(this.projectInfo, 'rewardOrgId', this.orgId)
      this.$set(this.projectInfo, 'rewardUserName', this.$decode(sessionStorage.getItem('userName')))
      this.$set(this.projectInfo, 'rewardUserId', this.$decode(sessionStorage.getItem('userId')))
    },
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //重置表单校验
    resetFields () {
      if (Array.isArray(this.$refs.projectForm)) {
        this.$refs.projectForm.every(ref => {
          ref.resetFields()
        })
      } else {
        this.$refs.projectForm.resetFields()
      }
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.projectInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.projectInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker') {
            this.$set(this.projectInfo, val.propertyCode, value ? timeFormat(value) : '')
          }
        })
      })
    },
    //获取信息 父组件调用
    async getPersonInfo (params) {
      await this.getCodeTable('KZ41')
      await this.getCodeTable('BOE32')
      await this.getCodeTable('BOE33')
      this.projectInfo = {}
      this.setInitData()
      if (params) {
        getExternalSignUp(params).then(({data}) => {
          if (params.quickFill) {
            data.isCancel = '0'
          }
          let isCancel = data.isCancel
          this.readOnly = isCancel == '1'
          this.projectInfo = { ...this.projectInfo, ...data }
          this.projectInfo.rewardTime = timeFormat(this.projectInfo.rewardTime)
          //设置附件
          if (this.projectInfo.attachmentGroupId) {
            this.groupId = this.projectInfo.attachmentGroupId
            this.getActivityFiles(this.groupId).then(data => {
              this.$set(this.projectInfo, 'uploadFile', data)
            })
          } else {
            this.groupId = this.getUuid()
          }
          this.$emit('on-request', {
            ...data,
            isCancel: isCancel
          })
          //动态表单
          this.dynamicList = this.list
          this.transferDataType()
        })
      } else {
        this.readOnly = false
        this.groupId = this.getUuid()
        //动态表单
        this.dynamicList = this.list
        this.transferDataType()
      }
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => ref.validateify())
      return req
    },
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submitPersonInfo (recommendInfo) {
      const applicationObjectId = this.getApplicationObjectId()
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$emit('on-close', 'valid')
          this.$Message.error('表单校验失败')
          return
        }
        const requestMethod = recommendInfo.signUpId ? editExternalSignUp : submitExternalSignUp
        const params = this.dateFormat({
          ...recommendInfo,
          ...this.projectInfo,
          attachmentGroupId: this.groupId,
          applicationObjectId: applicationObjectId
        })
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          if (!recommendInfo.signUpId) {
            this.$emit('on-request', {
              ...recommendInfo,
              signUpId: data.signUpId
            })
          } else {
            this.$emit('on-close')
          }
        }).catch(() => {
          this.$emit('on-close', 'valid')
        })
      })
    },
    //选择单位
    checkPerson (data, key) {
      if (key == 'rewardOrgName') {
        this.projectInfo.rewardOrgId = data[0].id
      }
    },
    checkMember ([item]) {
      this.$set(this.projectInfo, 'rewardUserId', item.userId || '')
      this.$set(this.projectInfo, 'rewardUserName', item.userName || '')
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    FormLayout,
    LayoutTitle
  }
}
</script>